import React from "react";

export const TableText = ({ title, isBold }) => {
  return (
    <React.Fragment>
      <label className={`fSize14 text-secondary ${isBold ? "fw-bold" : ""}`}>{title}</label>
    </React.Fragment>
  );
};
